import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';


const useStyles = makeStyles({
    chip: {
        marginTop: 4,
        marginBottom: 4,
        marginLeft: 2.5,
        marginRight: 2.5,
    }
});

export default function CandidateChip(props) {
    const classes = useStyles();

    const chipStyleOverride = {
        backgroundColor: props.color,
        color: props.textColor? props.textColor: 'black'
    };

    const iconStyleOverride = {
        color: props.textColor? props.textColor: 'inherit'
    };

    const [selected, setSelected] = React.useState(true);
    const [statusIcon, setStatusIcon] = React.useState(<RadioButtonUncheckedIcon style={iconStyleOverride}/>);

    const handleClick = () => {
        setSelected((prev) => !prev);
        props.onSelectionChange(props.label);
        if (selected) {
            setStatusIcon(<CheckCircleOutlineIcon style={iconStyleOverride}/>);
        } else {
            setStatusIcon(<RadioButtonUncheckedIcon style={iconStyleOverride}/>);
        }
    };

    return (
        <Chip
            label={props.label}
            icon={statusIcon}
            size='small'
            style={chipStyleOverride}
            className={classes.chip}
            onClick={handleClick}
            clickable
        />
    );
}
